import { Directive, Inject } from '@angular/core';
import { OPERATION_OVERLAY_LARGE_CONTENT_DATA } from '@fi-app/utilities/operation-overlay-large/operation-overlay-large-dialog/operation-overlay-large-dialog.component';

@Directive()
export abstract class ItemViewContainerBase {
    constructor(@Inject(OPERATION_OVERLAY_LARGE_CONTENT_DATA) data) {
        Object.assign(this, data);
    }
}
